// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent-module__pageContent--Omavx","animatedBackground":"PageContent-module__animatedBackground--0oP0h"};